
import { MainLayout } from '@/components/layout/MainLayout';
import { SidebarNavigation } from '@/components/navigation/SidebarNavigation';
import { SessionContent } from '@/components/session/SessionContent';
import { useStemSession } from '@/hooks/useStemSession';
import { Loader2 } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const AcapellaExtractor = () => {
  const isMobile = useIsMobile();
  const {
    acapellaSessions,
    isLoadingSessions,
    createSession,
    updateSession,
    deleteSession,
    isProcessing,
    setIsProcessing,
    progress,
    setProgress,
    processingDuration,
    setProcessingDuration,
    processingError,
    setProcessingError,
    handleFileSelect,
    activeSession,
    setActiveSession,
    retryProcessing,
    showDonationModal,
    donationModalSessionId,
    handleDonationModalClose,
    showDonationBanner,
    handleBannerClose,
  } = useStemSession();

  if (isLoadingSessions) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );
  }

  const currentSession = acapellaSessions?.find(s => s.id === activeSession.id);

  const handleDeleteSession = async (sessionId: string) => {
    if (sessionId === activeSession.id) {
      setActiveSession({ id: null, type: 'acapella' });
    }
    await deleteSession.mutateAsync({ id: sessionId });
  };

  return (
    <MainLayout>
      <SidebarNavigation
        sessions={[]}
        acapellaSessions={acapellaSessions || []}
        drumSessions={[]}
        activeSession={activeSession.id}
        onSessionSelect={(id) => setActiveSession({ id, type: 'acapella' })}
        onSessionDelete={handleDeleteSession}
        showStemSplitter={false}
        showAcapella={true}
        showDrumRemover={false}
      />
      <main className={`flex-1 ${isMobile ? 'w-full' : ''}`} style={{ backgroundColor: '#000000' }}>
        <SessionContent
          session={currentSession}
          isProcessing={isProcessing}
          progress={progress}
          processingError={processingError}
          processingDuration={processingDuration}
          onRetry={(id) => {
            setProcessingError(null);
            retryProcessing(id);
          }}
          onDelete={(id) => deleteSession.mutateAsync({ id })}
          onFileSelect={(file) => handleFileSelect(file, 'acapella')}
          sessionType="acapella"
          showDonationModal={showDonationModal}
          donationModalSessionId={donationModalSessionId}
          onDonationModalClose={handleDonationModalClose}
          showDonationBanner={showDonationBanner}
          onBannerClose={handleBannerClose}
        />
      </main>
    </MainLayout>
  );
};

export default AcapellaExtractor;
